import { styled } from "@pigment-css/react";
import { useTranslations } from "@acto/web-common/locales";
import { Flex } from "../../primitives";
import { formatPercentageChange } from "../../primitives/PercentageChip";

export const Description = styled("span")(({ theme }) => ({
  fontFamily: theme.managementView.font.familySecondary,
  fontSize: theme.managementView.font.size[14],
  fontWeight: theme.managementView.font.weight[500],
  color: theme.managementView.colors.neutral[56],
}));

export const TotalValue = styled("span")(({ theme }) => ({
  fontFamily: theme.managementView.font.familySecondary,
  fontSize: theme.managementView.font.size[21],
  fontWeight: theme.managementView.font.weight[500],
  color: theme.managementView.colors.neutral[90],
}));

const ComparisonValue = styled("span")(({ theme }) => ({
  fontFamily: theme.managementView.font.familySecondary,
  fontSize: theme.managementView.font.size[17],
  fontWeight: theme.managementView.font.weight[500],
  color: theme.managementView.colors.neutral[90],
}));

const TrendValue = styled(ComparisonValue)(({ theme }) => ({
  color: theme.managementView.colors.success[100],

  "&[data-trend='down']": {
    color: theme.managementView.colors.error[100],
  },
}));

interface MetricFiguresProps {
  label: string;
  value: string;
  comparison?: { label: string; value: string; percentageChange: number };
}

export const MetricFigures = ({ label, value, comparison }: MetricFiguresProps) => {
  const t = useTranslations();
  const trend = comparison && formatPercentageChange(comparison.percentageChange);

  return (
    <Flex direction="column" gap={24}>
      <Flex direction="column" gap={8}>
        <Description>{label}</Description>
        <TotalValue>{value}</TotalValue>
      </Flex>
      {comparison && trend && (
        <Flex gap={32}>
          <Flex direction="column" gap={8}>
            <Description>{comparison.label}</Description>
            <ComparisonValue>{comparison.value}</ComparisonValue>
          </Flex>
          <Flex direction="column" gap={8} align="start">
            <Description>{t("managementView.customerDetails.trend")}</Description>
            <TrendValue data-trend={trend.isPositive ? "up" : "down"}>{trend.text}</TrendValue>
          </Flex>
        </Flex>
      )}
    </Flex>
  );
};
